import StattionListView, { StationItem } from './StationListView/StationListView'
import useStation from '../../../hooks/useStation'
import SingleOrganization from '../../../../organization/components/SingleOrganization'
import { useNavigate } from 'react-router-dom'
import Pagination from '../../../../../common/components/organisme/Pagination/Pagination'
import { LoaderSreen } from '../../../../../common/components/molecule/Loader/Loader'
import ErrorScreenApp from '../../../../errorHandler/components/ErrorScreenApp/ErrorScreenApp'
import { OrderByType } from '../../../../../utils/genericAPI/useGenericAPI'
import { Station } from '../../../types/stations.types'
import { SingleStation } from '../../SingleStation'
import SingleHardware from '../../../../hardwares/components/SingleHardware'


/**
 * 
 * @param param0 
 * @returns 
 */
export default function StationListPresenter({pageSize, organizationId, orderBy}: {pageSize?: number, organizationId?: string, orderBy?: OrderByType<Station>}) {
    const {getAllStationQuery : { isError, isLoading, data: stationList, setPage, error}} = useStation({pageSize: pageSize || 8, organizationId, orderBy})
    const navigate = useNavigate()
    
    const handleclick = (stationId: string) => {
      console.log(stationId)
        navigate(`${stationId}`)
    }

    const content : StationItem[] = stationList?.data?.map((station) => ({
        id : station.station_id,
        name : station.station_name,
        city : station.station_city,
        country : station.station_country,
        hardwareId : station.station_hardware_id,
        OrganizationNameRender : () => (<SingleOrganization.Info id={station.station_organization_id} info="organization_name" limitText={13}/>),
        onClick : () => handleclick(station.station_id),
        nbChargePointRender : () => (<SingleStation.NbChargePoint stationId={station.station_id}/>),
        status: station.station_status,
        HardwareNameRender: () => <SingleHardware.DevUID hardwareId={station.station_hardware_id}/>,
    })) || []

    const pagination  = stationList?.pagination
  return (
    <>
    {isLoading && <LoaderSreen heigth={"200px"}/>}
    {error && <ErrorScreenApp axiosError={error}/>}
    {!isLoading && !isError &&
        <>
        <StattionListView content={content} nbFound={stationList?.pagination.total_count}/>
        <Pagination centered setCurrentPage={setPage} lastPage={pagination?.total_pages} currentPage={pagination?.current_page} nbBtnToDisplay={5}/>
        </>
    }

    </>
  )
}
